import React, { useState, useEffect, Fragment } from "react";
import { Plus, Trash2, UploadCloud } from "react-feather";
import { Button, Popconfirm, Input, Card, Tooltip, Table } from "antd";
import { red } from "@ant-design/colors";
import { Thead } from "../../components/Layout";
import "./Delivery.scss";
import debounce from "lodash/debounce";
import INFO_ROUND from '../../assets/images/info_round.svg'
import { InfoCircleOutlined } from "@ant-design/icons";

const DeliverySettingsContent = (props) => {
  const [zoneTypes, setzoneTypes] = useState([]);
  const deleteEmployee = async (id) => {
    props.deleteZone(id);
  };

  const addZone = async (id) => {
    if (id) {
      const data = zoneTypes.find((item) => item.id === id);
      const payload = {
        zone_name: data.zone_name,
        zone_radius: Number(data.zone_radius) || 0,
        delivery_fee: Number(data.delivery_fee) || 0,
        delivery_time_mins: Number(data.delivery_time_mins) || 0,
      };
      if (id && id === "new-column") props.addZone(payload);
      else props.updateZone(payload, id);
    }
  };

  const addColum = () => {
    const obj = {
      id: "new-column",
      zone_name: "",
      radius: "",
      fees: "",
      delivery_time_mins: ""
    };
    setzoneTypes([...zoneTypes, obj]);
  };

  useEffect(() => {
    if (props.zones) setzoneTypes(props.zones);
  }, [props.zones]);

  const handleInputChanges = debounce((inputValue, type, id) => {
    const data = zoneTypes.map((item) => {
      if (item.id === id) {
        if(type === 'zone_name'){
          item[type] = inputValue
        } else {
          item[type] = parseFloat(inputValue);
        }
        return item;
      } else {
        return item;
      }
    });
    setzoneTypes(data);
  }, 500);

  const changeZone = (evt, type, id) => {
    handleInputChanges(evt.target.value, type, id);
  };



  const columns = [
    {
      title: 
      (
        <Tooltip title="Name of the Delivery Zone">
          <span>
          Delivery zone&nbsp;
          <span className="ml-sm"><img src={INFO_ROUND} alt="" /></span>
          </span>
        </Tooltip>
      ),
     
      dataIndex: "name",
      key: "name",
      render: (et, record) => (
        <div className="p-1">
        <Input
          className="input-settings"
          placeholder="Enter zone"
          name="zone_name"
          defaultValue={record.zone_name}
          onChange={(event) =>
            changeZone(event, "zone_name", record.id)
          }
        />
      </div>
      ),
    },
    {
      title:
      (
        <Tooltip title="Delivery zone radius within which delivery is available">
          <span>
          Delivery Radius (mi)&nbsp;
          <span className="ml-sm"><img src={INFO_ROUND} alt="" /></span>
          </span>
        </Tooltip>
      ),
     
      dataIndex: "DeliveryRadius",
      key: "DeliveryRadius",
      render: (et, record) => (
        <div className="p-1">
                        <Input
                          className="input-settings"
                          placeholder="Enter radius"
                          name="zone_radius"
                          defaultValue={record.zone_radius}
                          onChange={(event) =>
                            changeZone(event, "zone_radius", record.id)
                          }
                        />
                      </div>
      ),
    },
    {
      title: 
      (
        <Tooltip title="Delivery Fees to deliver to this delivery zone">
          <span>
          Delivery Fees ($)&nbsp;
          <span className="ml-sm"><img src={INFO_ROUND} alt="" /></span>
          </span>
        </Tooltip>
      ),
      
      dataIndex: "DeliveryFees",
      key: "DeliveryFees",
      render: (et, record) => (
        <div className="p-1">
        <Input
          className="input-settings"
          placeholder="Enter fee"
          name="delivery_fee"
          defaultValue={record.delivery_fee}
          onChange={(event) =>
            changeZone(event, "delivery_fee", record.id)
          }
        />
      </div>
      ),
    },
    {
      title: 
      (
        <Tooltip title="Average time to deliver food to this delivery zone after the food is ready 
                (Please note that this does not include preparation time for the food)">
          <span>
          Delivery Time (avg)&nbsp;
          <span className="ml-sm"><img src={INFO_ROUND} alt="" /></span>
          </span>
        </Tooltip>
      ),
     
      dataIndex: "DeliveryTime",
      key: "DeliveryTime",
      render: (et, record) => (
        <div className="p-1">
                        <Input
                          className="input-settings"
                          placeholder="Enter time"
                          name="delivery_time_mins"
                          defaultValue={record.delivery_time_mins}
                          onChange={(event) =>
                            changeZone(event, "delivery_time_mins", record.id)
                          }
                        />
                      </div>
      ),
    },
    {
      title: "Action",
      dataIndex: "order_date",
      key: "order_date",
      render:(e,record)=> (<div>
        <Popconfirm
                        title="Save Zone"
                        onConfirm={() => addZone(record.id)}
                      >
                        <UploadCloud
                          color={red[5]}
                          className="cursor-pointer"
                        />
                      </Popconfirm>
                      <Popconfirm
                        title="Sure to delete?"
                        onConfirm={() => deleteEmployee(record.id)}
                      >
                        <Trash2
                          className="ml-1 cursor-pointer"
                          color={red[5]}
                        />
                      </Popconfirm>
      </div>)
    },
   
   
  ];

  return (
    <Card className="card-qr">
      <div style={{ padding: "15px 30px" }}>
        <div className="flex" style={{ justifyContent: "end" }}>
          <Button className="flex mb-1" type="link" onClick={() => addColum()}>
            <Plus size={22} /> <span style={{ marginLeft: 4 }}>Add Zone</span>
          </Button>
        </div>
        <div className="site-layout-background">
        <Table columns={columns} dataSource={zoneTypes} 
            className="overflow-auto deliver-setting-table"
          />
        </div>
       

        {/* <Button onClick={()=>addZone()} className="save-btn" size="large" type="primary">Save</Button> */}
      </div>
    </Card>
  );
};

export default DeliverySettingsContent;
